var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 5.15a2.99 2.99 0 0 0-2.31-1.29L7.42 3.02l-.12-.61A3.01 3.01 0 0 0 4.36 0H1C.45 0 0 .45 0 1s.45 1 1 1h3.36c.48 0 .89.34.98.8l2.2 10.98A4.01 4.01 0 0 0 11.46 17h8.82c1.74 0 3.28-1.12 3.81-2.78l2.07-6.44c.29-.89.15-1.85-.39-2.62zm-1.52 2.01-2.07 6.44c-.27.83-1.03 1.39-1.9 1.39h-8.82c-.95 0-1.77-.68-1.96-1.61L7.83 5.03l15.53.82a1 1 0 0 1 .9 1.3zM12 22.99a2 2 0 1 0 0-4 2 2 0 0 0 0 4m8 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    fill: "#000",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.e0920a08f3fa87b203287aeaf5d4933e.svg";
export { ForwardRef as ReactComponent };